


















import FullHeader from "../components/FullHeader/FullHeader.vue";
import Footer from "../components/Footer.vue";
import Blog from '../components/Blog/Blog.vue';
import Posts from '../components/Posts/Posts.vue';
import Services from '../components/Services/Services.vue';
import Businesses from '../components/TopBusinesses/Businesses.vue';
import { Component, Vue } from 'vue-property-decorator';
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    FullHeader,
    Services,
    Posts,
    Blog,
    Businesses,
    Footer,
    InfiniteLoading
  },
})
export default class LandingPage extends Vue {
  loadedUntil = 2;

  getMoreParts ($state?: any) {
      this.loadedUntil++;
    if ($state) {
        $state.loaded();
        if (this.loadedUntil>=5) $state.complete();
    }
  }
}
